import React, { useState } from 'react';
import axios from 'axios';

const ImportCSV = () => {
  const [file, setFile] = useState(null);

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onUpload = async () => {
    try {
      const formData = new FormData();
      formData.append('csv', file);

      const response = await axios.post('http://161.97.115.122:5000/import-csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        if (response.data.failedRows && response.data.failedRows.length > 0) {
          console.error('Nie udało się zaimportować niektórych wierszy:', response.data.failedRows);
          alert('Niektóre wiersze nie zostały zaimportowane. Sprawdź konsolę, aby uzyskać więcej informacji.');
        } else {
          alert('Plik został pomyślnie przesłany i przetworzony!');
        }
      } else {
        alert('Wystąpił błąd podczas przesyłania pliku.');
      }
    } catch (error) {
      console.error('Błąd podczas przesyłania pliku:', error);
      alert('Wystąpił błąd podczas przesyłania pliku.');
    }
  };

  return (
    <div className="ImportCSV">
      <h1>Prześlij plik CSV</h1>
      <input type="file" accept=".csv" onChange={onFileChange} />
      <button onClick={onUpload}>Prześlij</button>
    </div>
  );
};

export default ImportCSV;
